//
//
//
//
//
//
//
//
//
export default {
  name: 'u8-icon-btn',
  props: {
    icon: {
      default: ''
    },
    tip: {
      default: ''
    }
  },
  methods: {
    onIconClick: function onIconClick() {
      this.$emit('click');
    }
  }
};